<template>
  <div class="products-management-page">
    <custom-tabs
      v-model="activeTab"
      :tab-items="tabs"
      class="mx-2 my-4"
      grow
    >
      <template #staticItems>
        <!-- تب اول: تک محصولی -->
        <v-tab-item>
          <link-digi-product-model_single
            v-if="activeTab === 0"
            :product-digi="productDigi"
            @close="$emit('close')"
            @saved="$emit('saved')"
          />
        </v-tab-item>

        <!-- تب دوم: چند محصولی (پک) -->
        <v-tab-item>
          <link-digi-product-model_-pack
            v-if="activeTab === 1"
            :product-digi="productDigi"
            @close="$emit('close')"
            @saved="$emit('saved')"
          />
        </v-tab-item>
      </template>
    </custom-tabs>
  </div>
</template>

<script>
import LinkDigiProductModel_Pack from "./linkDigiProductModel_Pack.vue";
import LinkDigiProductModel_single from "./linkDigiProductModel_single.vue";

export default {
  name: "LinkDigiProductModal",
  components: {
    LinkDigiProductModel_Pack,
    LinkDigiProductModel_single,
  },
  props: {
    productDigi: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      activeTab: 0,
      tabs: [
        { text: "تک محصولی", icon: "package" },
        { text: "چند محصولی (پک)", icon: "package-variant" },
      ],
    };
  },
};
</script>
